import {createFileRoute} from '@tanstack/react-router';

import {CreateSeverityScaleForm} from '@/features/Library/components/Severity/CreateSeverityScaleForm';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/_library/severities/create')({
  component: CreateSeverityScaleForm,
  beforeLoad: () => makeDocumentTitle('Create Severity'),
});
